import { Fragment, h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style.css';
import Store from '../../stores/Store';
import * as files from '../../assets/files.json';

const Sidebar = () => {
  const store = new Store();

  return (
    <div
      class="offcanvas offcanvas-end"
      tabIndex={-1}
      id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel"
    >
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasNavbarLabel">
          <img src={files.logo} class={style.logo_sidebar} alt="logo" />
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
      </div>
      <div class="offcanvas-body">
        <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
          <li class="nav-item">
            <Link class="nav-link" activeClassName="active" href="/">
              <div class="flex">
                <img
                  src="/pera-asset-v1/images/icons/icon-home.svg"
                  width="20"
                />
                &nbsp;
                <span>Home</span>
              </div>
            </Link>
          </li>
          <li class="nav-item">
            <Link class="nav-link " activeClassName="active" href="/articles">
              <div class="flex">
                <img
                  src="/pera-asset-v1/images/icons/icon-must-read.svg"
                  width="20"
                />
                &nbsp;
                <span style="white-space: nowrap">Must Read</span>
              </div>
            </Link>
          </li>
          <li class="nav-item">
            <a class="nav-link " aria-current="page" href="/support/faq">
              <div class="flex">
                <img
                  src="/pera-asset-v1/images/icons/icon-support.svg"
                  width="20"
                />
                &nbsp;
                <span>Support</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <Link
              class="nav-link "
              activeClassName="active"
              aria-current="page"
              href="/about"
            >
              <div class="flex">
                <img
                  src="/pera-asset-v1/images/icons/icon-about.svg"
                  width="20"
                />
                &nbsp;
                <span style="white-space: nowrap">About Us</span>
              </div>
            </Link>
          </li>
          {(() => {
            return store.isLoggedIn() ? (
              <ActionIsLogin />
            ) : (
              <ActionIsNotLogin />
            );
          })()}
        </ul>
      </div>
    </div>
  );
};

const ActionIsNotLogin = props => {
  return (
    <>
      <li class="nav-item">
        <Link class="nav-link" activeClassName="active" href="/products">
          <div class="flex">
            <img
              src="/pera-asset-v1/images/icons/icon-products.svg"
              width="20"
            />
            &nbsp;
            <span style="white-space: nowrap">Products & Services</span>
          </div>
        </Link>
      </li>
      <li class="nav-item">
        <div class="nav-link">
          <div>
            <Link class="btn btn-success" href="/login">
              Login
            </Link>
            &nbsp; &nbsp;
            <Link class="btn btn-outline-warning" href="/signup">
              Register
            </Link>
          </div>
        </div>
      </li>
    </>
  );
};

const ActionIsLogin = props => {
  return (
    <Fragment>
      <li class="nav-item">
        <Link
          class="nav-link"
          activeClassName="active"
          href="/redirect/pera/packages"
        >
          <div class="flex">
            <img
              src="/pera-asset-v1/images/icons/icon-products.svg"
              width="20"
            />
            &nbsp;
            <span style="white-space: nowrap">Products & Services</span>
          </div>
        </Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link " aria-current="page" href="/redirect/cart">
          <div class="flex">
            <img src="/pera-asset-v1/images/icons/icon-cart.svg" width="20" />
            &nbsp;
            <span>Cart</span>
          </div>
        </Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link " aria-current="page" href="/profile">
          <div class="flex">
            <img
              src="/pera-asset-v1/images/icons/icon-profile.svg"
              width="20"
            />
            &nbsp;
            <span>Profile</span>
          </div>
        </Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link " aria-current="page" href="/redirect/dashboard">
          <div class="flex">
            <img
              src="/pera-asset-v1/images/icons/icon-dashboard.svg"
              width="20"
            />
            &nbsp;
            <span>Dashboard</span>
          </div>
        </Link>
      </li>

      <li class="nav-item">
        <Link
          class="nav-link "
          aria-current="page"
          href={`/logout?token=${props.token || ''}`}
        >
          <div class="flex">
            <img src="/pera-asset-v1/images/icons/icon-logout.svg" width="20" />
            &nbsp;
            <span>Logout</span>
          </div>
        </Link>
      </li>
    </Fragment>
  );
};

export default Sidebar;
